// Registry of the panels listed in the dev-tools modal (Cmd+D). Append new
// tools at the end; each entry owns its shortcut matcher so the modal and the
// keyboard listener share one source of truth.
export type DevToolId = 'feature-flags' | 'matrix'

export type DevTool = {
  id: DevToolId
  name: string
  description: string
  /** Displayed next to the tool name in the list. */
  shortcut: string
  /** Matches while the dev-tools modal is open. */
  matchesShortcut: (event: KeyboardEvent) => boolean
}

export const DEV_TOOLS: readonly DevTool[] = [
  {
    id: 'feature-flags',
    name: 'Feature flags',
    description: 'Force feature flags on/off client-side, overriding the API value.',
    shortcut: 'Shift+F',
    matchesShortcut: event =>
      event.shiftKey &&
      !event.metaKey &&
      !event.ctrlKey &&
      !event.altKey &&
      event.key.toLowerCase() === 'f'
  },
  {
    id: 'matrix',
    name: 'Matrix',
    description: 'Point the app at another backend — ARA and scoping base URLs.',
    shortcut: 'Shift+M',
    matchesShortcut: event =>
      event.shiftKey &&
      !event.metaKey &&
      !event.ctrlKey &&
      !event.altKey &&
      event.key.toLowerCase() === 'm'
  }
]
